<div class="not-found flex flex-col min-h-full min-w-full justify-center items-center">
    <div class="text-center text-5xl font-bold">404</div>
    <div class="text-center text-2xl font-bold">Page Not Found</div>
</div>
